import React, { useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { PickList } from 'primereact/picklist';
import { Button } from 'primereact/button';
import { PessoaType, GroupType } from '../../db/Orm';
import API from '../../api/API';
import * as messages from '../../utils/messages';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

interface TabUsuarioPermissoesProps {
    pessoas: PessoaType[];
    grupos: GroupType[];
    pessoa: PessoaType;
    setPessoa: (pessoa: PessoaType) => void;
    error: () => void;
}

const TabUsuarioPermissoes: React.FC<TabUsuarioPermissoesProps> = ({
    pessoas,
    grupos,
    pessoa,
    setPessoa,
    error
}) => {
    const [loading, setLoading] = useState(false);
    const toast = useRef<Toast>(null);

    const availableGroups = pessoa.user ? grupos.filter(g => 
        !pessoa.user.groups.some((pg: GroupType) => pg.id === g.id)
    ) : grupos;

    const targetGroups = pessoa.user ? pessoa.user.groups : [];

    const onChange = (event: { source: GroupType[], target: GroupType[] }) => {
        if (pessoa.user) {
            const newPessoa = {...pessoa, user: {...pessoa.user, groups: event.target}};
            setPessoa(newPessoa);
        }
    }

    const handleSave = () => {
        if (pessoa.user) {
            setLoading(true);
            API.updateUserGroups(pessoa.user.id, pessoa.user.groups.map((g: any) => g.id))
                .then(() => {
                    messages.message(toast.current, 'Grupos de usuário atualizados com sucesso', 'success');
                    setLoading(false);
                })
                .catch(() => {
                    error();
                    setLoading(false);
                });
        }
    };

    return (
        <div className="p-fluid">
            <Toast ref={toast} />
            <div className="p-field">
                <label htmlFor="pessoa">Pessoa</label>
                <Dropdown id="pessoa" value={pessoa} options={pessoas} onChange={(e) => setPessoa(e.value)} placeholder="Selecione uma pessoa" optionLabel="nome_razao" dataKey="id" />
            </div>
            {pessoa.user &&
                <>
                    <div className="p-field">
                        <PickList
                            source={availableGroups}
                            target={targetGroups}
                            itemTemplate={(item: GroupType) => <div>{item.name}</div>}
                            sourceHeader="Grupos Disponíveis"
                            targetHeader="Grupos da Pessoa"
                            dataKey="id"
                            onChange={onChange}
                            showSourceControls={false}
                            showTargetControls={false}
                        />
                    </div>
                    <div className="p-field">
                        <Button label="Salvar" icon={loading ? <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8" /> : "pi pi-check"} disabled={loading} onClick={handleSave} />
                    </div>
                </>
            }
        </div>
    );
};

export default TabUsuarioPermissoes;